import type { TextStyleValue } from '@elfsight/configurator-contracts';

export const INTEGRATION_STRIPE_SETTINGS_KEY = 'integrationStripe';

export const STYLE_DEFAULTS: TextStyleValue & {
  textColor: string;
  accentColor: string;
  errorColor: string;
} = {
  textColor: '#111',
  accentColor: '#197BFF',
  errorColor: '#FF3838',
  fontSize: 15,
  lineHeight: '20px',
  fontWeight: 400,
  textAlign: 'center'
};

export const TEXT_ACTION_ELEMENT_FONT_STYLE: TextStyleValue = {
  fontSize: 13,
  fontWeight: 500,
  lineHeight: '16px'
};

export const CLASS_COMPONENT = 'payment-form';

export const SUBSCRIBER_TOKEN_HEADER = 'x-mercure-subscriber-token';

export const PUBLIC_KEY_REGEX = /^pk_(live|test)_[A-Za-z0-9]{24,}$/;

// Restricted-ключи с пермишенами
// Payment Methods (write), Checkout Sessions (write) и Customers (write)
// тоже являются рабочими
export const SECRET_KEY_REGEX = /^(sk|rk)_(live|test)_[A-Za-z0-9]{24,}$/;

export const ENDPOINTS = {
  manipulateIntegration: 'integration',
  createPayment: 'checkout/payment',
  createSubscription: 'checkout/subscription',
  getSessionData: 'checkout'
} as const;

export const ZAPIER_PAYMENT_FIELDS = [
  {
    id: 'payment_status',
    name: 'Payment Status',
    sample: 'Payment Received'
  },
  {
    id: 'price',
    name: 'Price',
    sample: '$42'
  },
  {
    id: 'amount_paid',
    name: 'Amount Paid',
    sample: '$42'
  },
  {
    id: 'payment_method',
    name: 'Payment Method',
    sample: 'Visa'
  },
  {
    id: 'card_last_4_digits',
    name: 'Card Last 4 Digits',
    sample: '4242'
  },
  {
    id: 'transaction_id',
    name: 'Transaction ID',
    sample: 'ch_3MmlLrLkdIwHu7ix0snN0B15'
  },
  {
    id: 'payment_date',
    name: 'Payment Date',
    sample: '2026-01-15T10:00:00+03:00'
  },
  {
    id: 'receipt_link',
    name: 'Receipt Link',
    sample:
      'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xTTJKVGtMa2RJd0h1N2l4KOvG06AGMgZfBXyr1aw6LBa9vaaSRWU96d8qBwz9z2J_CObiV_H2-e8RezSK_sw0KISesp4czsOUlVKY'
  },
  {
    id: 'refund_link',
    name: 'Refund Link',
    sample: 'https://dashboard.stripe.com/payments/pi_3MtwBwLkdIwHu7ix28a3tqPa'
  }
];

export const DEFAULT_STRIPE_INTEGRATION = {
  id: '',
  publishableKey: '',
  cancellationPolicyText: ''
};

export const integrationStripeSettings = {
  [INTEGRATION_STRIPE_SETTINGS_KEY]: DEFAULT_STRIPE_INTEGRATION
};
